import React from 'react';

import { FormattedMessage } from '@futrli/localisation';

interface ResourceAccessLabelProps {
  permission?: 'edit' | 'no-access' | 'view';
}

export const ResourceAccessLabel = ({ permission }: ResourceAccessLabelProps) => {
  switch (permission) {
    case 'edit':
      return <FormattedMessage id="common.edit" defaultMessage="Edit" />;
    case 'view':
      return <FormattedMessage id="sharing.view_only" defaultMessage="View only" />;
    default:
      return <FormattedMessage id="sharing.none" defaultMessage="None" />;
  }
};
